<template> 
    <div>
        <div v-if="isRadioType" class="d-flex align-items-center">
            <input
                :id="id"
                type="radio"
                :value="id"
                v-model="innerRadio"
                :name="name"
                :checked="innerSelected"
                :disabled="disabled"
            />
            <label
                :for="id"
                class="my-0 ml-2"
            >
                {{ label }}
            </label>
        </div>
        
        <div v-else class="custom-control custom-checkbox">
            <input
                :id="id"
                type="checkbox"
                class="custom-control-input"
                v-model="innerSelected"
                :name="name"
                :disabled="disabled"
            />
            <label
              :for="id"
              class="custom-control-label font regular"
            >
                {{ label }}
            </label>
        </div>
    </div>
</template>

<script>
import { SelectorTypeEnum } from './SelectorTypeEnum';

export default {
    name: 'SingleOption',
    props: {
        id: {
            type: [Number, String],
            default: 1,
        },
        value: {
            type: Boolean,
            default: false,
        },
        name: {
            type: [Number, String],
            default: 1,
        },
        label: {
            type: String,
            default: "",
        },
        type: {
            type: [Number, String],
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        innerSelected: false,
        innerRadio: null,
    }),
    methods: {
    },
    computed: {
        isRadioType() {
            return this.type == SelectorTypeEnum.RadioButton;
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(newValue) {
                this.innerSelected = newValue;
                
                if (!this.isRadioType) return;
                
                this.innerRadio = newValue ? this.id : null;
            },
        },
        innerRadio(newValue) {
            this.$emit('input', newValue == this.id);
            this.$emit('radio-input');
        },
        innerSelected(newValue) {
            this.$emit('input', newValue);
            this.$emit('checkbox-input');
        }
    }
}
</script>

<style scoped src="@/assets/css/component/checkbox.css"></style>


<style scoped>
input:disabled {
    cursor: not-allowed;
    background-color: #f1f1f1 !important;
}

/*CUSTOM RADIO*/
input[type="radio"] {
  -webkit-appearance: none;
  appearance: none;
  background-color: white;
  margin: 0;
  font: inherit;
  min-width: 1em;
  min-height: 1em;
  border: 0.1em solid #aeb6be;
  border-radius: 50%;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
}

input[type="radio"]::before {
  content: "";
  min-width: 0.37em;
  min-height: 0.37em;
  border-radius: 50%;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em white;
  background-color: #2db782;
}

input[type="radio"]:checked::before {
  transform: scale(1);
}

input[type="radio"]:checked {
  background-color: #2db782 !important;
  border: none;
}
</style>